import { TextInput as IsTextInput } from 'is24-corecss'
import { ReactChild } from 'react'
import styled from 'styled-components'

type TextInputProps = {
  textColor?: string
  borderColor?: string
  backgroundColor?: string
  id: string
  placeholder: string
  errorMessage?: string
  label: ReactChild
  helperText?: string
  valid?: boolean
  success?: boolean
  affixLeft?: 'none' | 'unit' | 'icon'
  unitLeft?: 'none' | 'percent' | 'sqm' | 'eur' | 'eurPerSqm' | 'years' | 'months'
  iconLeft?: string
  affixRight?: 'none' | 'unit' | 'icon'
  unitRight?: 'none' | 'percent' | 'sqm' | 'eur' | 'eurPerSqm' | 'years' | 'months'
  iconRight?: string
  mandatory?: boolean
} & Omit<JSX.IntrinsicElements['input'], 'children'>

const TextInput = styled(IsTextInput)<TextInputProps>`
  ${({ backgroundColor }) =>
    backgroundColor &&
    `#rle-wizard & ,input, button {
     background-color: ${backgroundColor} !important;
   }
 `}
  ${({ borderColor }) =>
    borderColor &&
    `#rle-wizard & ,input, button {
     border-color: ${borderColor} !important;
    }
 `}
  ${({ textColor }) =>
    textColor &&
    `#rle-wizard & ,input, button {
    color: ${textColor} !important;
   }
 `}
`
export { TextInput }
